$(window).on( 'load', function() {
	if ($('video')[0] && !$('video').attr('autoplay')) {
		handlePlayVideo();
		$('.post-content').find('video').removeAttr('controls');
	}
});


function handlePlayVideo() {

	$('<div class="play-button"><svg xmlns="http://www.w3.org/2000/svg" width="136" height="152" viewBox="0 0 136 152"><g><g transform="rotate(90 68 76)"><path fill="#fff" d="M68 8.617l75.528 134.766H-7.528z"/></g></g></svg></div>').insertBefore(".post-content video");

	$(".play-button").on('click', function(e) {
		$(this).next('video').trigger('play').attr('controls','');
		$(this).fadeOut();
		/* $(this).next('video').on("ended", function (e) {
			$(this).prev('.play-button').fadeIn();
			$(this).next('video').trigger('play');
		}); */
	});

}